import React from 'react'
import ImgFront from '../../images/front.jpg'
import './postCardFront.scss'

const PostCardFront = () => {
  return <img className="PostCardFront" src={ImgFront} alt="Cora and Lily at sunrise" />
}

export default PostCardFront
